import { Injectable } from '@angular/core';
import { BaseDataService } from './base.data.service';
import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { ISupplierAvailabilityDashboardFilter } from '../interfaces/supplier-availability-dashboard/supplier-availability-dashboard-filter';

@Injectable({
  providedIn: 'root',
})
export class SupplierAvailabilityDashboardService extends BaseDataService {
  public url = '/api/supplierAvailabilityDashboard';

  constructor(public http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getSupplierAvailability(
    filterCommand: ISupplierAvailabilityDashboardFilter,
  ): Promise<any> {
    return this.http
      .get<any>(`${this.url}/load`, {
        params: this.constructHttpParams(filterCommand),
      })
      .toPromise();
  }

  public getSupplierDropdownItems(): Promise<any> {
    return this.http.get<any>(`${this.url}/suppliers`).toPromise();
  }

  public downloadReport(filterCommand: ISupplierAvailabilityDashboardFilter) {
    let params = this.constructHttpParams(filterCommand);
    return this.http.get(this.url + '/export', { params: params, responseType: 'blob' });
  }

  public updateSupplierAvailability(
    organisationId: number,
    previousStatusId: number,
    newStatusId: number,
    filterDate: string,
  ): Promise<void> {
    const body = {
      organisationId,
      previousStatusId,
      newStatusId,
      filterDate,
    };

    return this.http.post<void>(`${this.url}/updateSupplierAvailabilityStatus`, body).toPromise();
  }
}
